import { cn } from '../../lib/cn';
import { useNudgeImpression } from '../../hooks/useNudgeImpression';
import { analytics } from '../../lib/analytics';
import { Zap } from 'lucide-react';
import { formatCurrency } from '../../utils/format';
import type { FastagProfile } from '../../types';

interface NudgePayNowAdjacencyProps {
  profile: FastagProfile;
  visible: boolean;
  onRecharge: () => void;
}

export function NudgePayNowAdjacency({
  profile,
  visible,
  onRecharge,
}: NudgePayNowAdjacencyProps) {
  useNudgeImpression('nudge_paynow_adjacency', visible, { balance: profile.balance });

  if (!visible) return null;

  const handleClick = () => {
    analytics.emit('recharge_cta_click', { nudge_id: 'nudge_paynow_adjacency', balance: profile.balance });
    onRecharge();
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'mx-4 mb-3 flex w-auto items-center gap-2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-left transition-colors hover:bg-amber-100 focus-visible:ring-2 focus-visible:ring-park-500 dark:border-amber-800 dark:bg-amber-900/20 dark:hover:bg-amber-900/30'
      )}
      data-testid="nudge-paynow-adjacency"
      aria-label={`FASTag balance ${formatCurrency(profile.balance)}, recharge before paying challans`}
    >
      <Zap className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
      <span className="text-sm font-medium text-amber-900 dark:text-amber-100">
        FASTag {formatCurrency(profile.balance)} — Recharge {formatCurrency(profile.recommendedAmount)}
      </span>
    </button>
  );
}
